module.exports = __webpack_public_path__ + "img/16.2a9c6375.jpg";